import { CompanyAddressDto, CompanyDto, PersonDto } from 'dtos'
import * as yup from 'yup'

export class MichiganTitleApplicationCoverLetterDto {
  dropOffDate?: string = undefined
  dropOffTime?: string = undefined
  michiganSOSBranchCompany?: CompanyDto = undefined
  michiganSOSBranchCompanyAddress?: CompanyAddressDto = undefined
  /**
   * Description:
   * A free-text field.
   * By default, it is populated with “Canadian Ownership to Michigan Title.”
   * This field is required.
   */
  description?: string = 'Canadian Ownership to Michigan Title.'
  contactPerson?: PersonDto = undefined
}

export const miTitleApplicationCoverLetterValidationSchema = yup.object({
  dropOffDate: yup.string().required('Drop Off Date is required.'),
  dropOffTime: yup.string().required('Drop Off Time is required.'),
  michiganSOSBranchCompany: yup.object().required('MI SoS Branch is required.'),
  michiganSOSBranchCompanyAddress: yup.object().required('MI SoS Branch Address is required.'),
  description: yup.string().max(200, 'Description cannot be more than 200 characters.').required('Description is required.'),
  contactPerson: yup.object().required('Contact Person is required.')
})
